import { createRouter } from "@tanstack/react-router";

import { queryClient } from "./lib";
import { routeTree } from "./RouteTree";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  context: {
    queryClient,
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }

  interface StaticDataRouteOption {
    getPageTitle?: () => string;
  }
}
